import React from 'react';
import { IconQuestionCircle } from '@creditas-ui/icons';
import { GlobalIcons } from '@creditas-ui/global-icons';
import { ButtonSecondary } from '@creditas-ui/react';

import { DesktopLogo, HelpTextDesktop, Logo } from './header.styles';
import HelpModalComponent from '../components/HelpModal/helpModal.component';
import { useHeader } from './header.hook';

const large = `${process.env.PUBLIC_URL}/public/img/desktop-logo.svg`;
const small = `${process.env.PUBLIC_URL}/public/img/logo.svg`;

const HeaderComponent: React.FC = () => {
  const { contactList, isOpen, handleContactRedirect, toggleModal } = useHeader();
  return (
    <>
      <Logo src={small} alt="Creditas" />
      <DesktopLogo src={large} alt="Creditas" />
      <ButtonSecondary onClick={toggleModal}>
        <GlobalIcons Icon={IconQuestionCircle} size="medium" color={'#596b64' as any} />
        <HelpTextDesktop variant="bodyMdRegular" component="span" color="neutral.80">
          ¿Necesitas ayuda?
        </HelpTextDesktop>
      </ButtonSecondary>
      <HelpModalComponent
        isOpen={isOpen}
        closeModal={toggleModal}
        handleContactRedirect={handleContactRedirect}
        contactList={contactList}
      />
    </>
  );
};

export default HeaderComponent;
